/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-download-xl': {
    width: 20,
    height: 16,
    viewBox: '0 0 20 16',
    data: '<path pid="0" d="M19.5 7.932a.5.5 0 0 1 .492.41l.008.09v7a.5.5 0 0 1-.41.492l-.09.008H.5a.5.5 0 0 1-.492-.41L0 15.432v-7a.5.5 0 0 1 .992-.09l.008.09-.001 6.5h18l.001-6.5a.5.5 0 0 1 .41-.492l.09-.008zM9.915.068a.5.5 0 0 1 .495.407l.01.09.075 10-.002.016 2.68-2.295a.5.5 0 0 1 .713.695l-.063.065-3.502 3a.5.5 0 0 1-.577.052l-.074-.053-3.493-3a.5.5 0 0 1 .578-.81l.073.052 2.668 2.29v-.005l-.077-10a.5.5 0 0 1 .496-.504z" _fill="#0D204A" fill-rule="evenodd"/>'
  }
})
